var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaRightBranca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.005,
    height: 16.539,
    viewBox: "0 0 11.005 16.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seta-right-branca",
    transform: "translate(0.505 0.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M3.152,291.965a1.1,1.1,0,0,0-.726,1.954L9.177,299.7l-6.752,5.782a1.1,1.1,0,1,0,1.433,1.67l7.73-6.614a1.1,1.1,0,0,0,0-1.679l-7.73-6.62a1.1,1.1,0,0,0-.707-.278Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaRightBranca);
export default __webpack_public_path__ + "static/media/seta-right-branca.39ca0dafbcf02890f43642c387d8fd13.svg";
export { ForwardRef as ReactComponent };